import React, { useEffect, useRef, useState } from "react";

import {
    Modal,
    Platform,
    Text,
    TouchableOpacity,
    View
} from "react-native";
import PlayButton from "../../../designSystem/PlayButton";
import PremiumButton from "../../../designSystem/PremiumButton";
import i18n, { getLanguage } from "../../../utils/Localization/Localization";
import AppTheme from "../../../utils/Theme";

// Analytics
import { trackEvent, analyticsEventActivityLaunch, propertiesEventContext, propertiesEventContent, propertiesEventAccess, propertiesEventCategory, propertiesEventCompleted, propertiesEventSection, propertiesEventName, analyticsEventActivityCompleted, analyticsEventActivityDownloaded, propertiesEventProfile, analyticsEventWorkshopLaunched, analyticsEventWorkshopCompleted, analyticsEventMediaLaunch, propertiesEventContentName } from "../../../services/Tracking/Analytics";
import User from "../../../data/user/User";
import ActivityPlayer from "../../Audio/ActivityPlayer";
import ActivityIndicator from "../../../designSystem/ActivityIndicator/ActivityIndicator";
import { getUrlsToUse } from "../../../utils/LocalStorage";
import { onActivityCompleted } from "../../../services/Firebase/Database";
import Activity, { actionChoice } from "../../../models/Activity";
import Style from "../../../utils/Style";
import SVGView from "../../../utils/SvgView";

import ActionSheet from "../../ActionSheets/ActionSheet";
import RoundIconButton from "../../../designSystem/RoundIconButton";
import PDFViewer from "../../../../specific/components/PDF/PDFViewer";
import { getAppTarget } from "../../../../specific/utils/Navigation/Host";
import { getDocumentUrlForActivityId } from "../../../../specific/services/AppWrite/AppWriteDatabase";
import { IcClose, IcDocument, IcFilm, IcHeadphones, IcKeyImages, IcTapuscrit } from "../../../utils/Icons";
import ImagesSlideshow from "../../../../specific/components/Images/ImagesSlideshow";
import { useNavigate } from "../../../../specific/utils/Navigation/Navigation";
import Images from "../../../../specific/utils/Images";

type localizedString = {
    fr?: string
}

interface ActivityCellBodyProps {
    activity: Activity;
    color: string;
    modal_color?: string;
    width: number;
    isEnable?: boolean; // Définit si l'activité est gratuite ou si premium, que l'utilisateur a bien un abo
    urls?: string[];
    componentId?: string;
    context: string,
    categoryAnalyticsKey: string,
    sectionAnalyticsKey: string,
    title: localizedString,
    localImgPath: string,
    categoryKey: string,
    sub_type: string,
    starting_point?: "superpower" | "section"
}

type audioVersionType = "ORIGINAL" | "ADAPTED" | "NONE";

const ActivityCellActionAudio = (props: ActivityCellBodyProps) => {
    const { color, width, isEnable = false, urls = [], componentId = "", context, categoryAnalyticsKey, sectionAnalyticsKey, title, localImgPath, categoryKey, activity, sub_type, modal_color, starting_point = "superpower" } = props;

    const appTheme: AppTheme = new AppTheme();
    const images: Images = new Images();
    const user: User = User.getInstance();
    const [launchPlayer, setLaunchPlayer] = useState<boolean>(false);
    const [showChoices, setShowChoices] = useState<boolean>(false);
    const [showTranscriptChoices, setShowTranscriptChoices] = useState<boolean>(false);
    const [selectedChoice, setSelectedChoice] = useState<{ key?: string, urls?: string[] }>({});
    const [viewDidAppear, setViewDidAppear] = useState<boolean>(false);
    const [audioUrls, setAudioUrls] = useState<string[]>([]);
    const [launchDocument, setLaunchDocument] = useState<boolean>(false);
    const [launchImagesSlideshow, setLaunchImagesSlideshow] = useState<boolean>(false);
    const [audioVersion, setAudioVersion] = useState<audioVersionType>("NONE");
    const [transcriptVersion, setTranscriptVersion] = useState<audioVersionType>("NONE");

    const actionSheetRef = useRef<ActionSheet>(null);

    const appTarget = getAppTarget();

    let navigate: any = null;
    if (Platform.OS === "web") {
        navigate = useNavigate();
    }

    useEffect(() => {
        if (audioUrls.length > 0) {
            setViewDidAppear(true);
        }
    }, [audioUrls]);

    const onViewDidAppear = () => {
        setUrls();
    }

    const setUrls = async () => {
        let urlToLaunch: any[] = [];
        if (appTarget === "public") {
            if (activity.sectionKey === "still") {
                urlToLaunch.push(require("../../../assets/audio/lili_je_me_pose.mp3"));
            } else if (activity.sectionKey === "talk") {
                urlToLaunch.push(require("../../../assets/audio/lili_je_m_exprime.mp3"));
            }
        }

        let audioUrls = await getUrlsToUse({ urls, activityKey: activity.key });
        urlToLaunch = urlToLaunch.concat(audioUrls);
        if (appTarget === "public") {
            if (activity.sectionKey === "still") {
                urlToLaunch.push(require("../../../assets/audio/lili_je_me_pose.mp3"));
            } else if (activity.sectionKey === "talk") {
                urlToLaunch.push(require("../../../assets/audio/lili_je_m_exprime.mp3"));
            }
        }

        setAudioUrls(urlToLaunch);
    }

    useEffect(() => {
        if (launchPlayer === true) {
            trackEvent(analyticsEventActivityLaunch, {
                [propertiesEventCategory]: categoryAnalyticsKey,
                [propertiesEventContent]: sub_type,
                [propertiesEventAccess]: activity.isPremium() === true ? "premium" : "free",
                [propertiesEventContext]: context,
                [propertiesEventName]: activity.analytics_key,
                "starting_point": starting_point
            });
        }
    }, [launchPlayer]);

    useEffect(() => {
        if (selectedChoice.key !== undefined) {
            setLaunchPlayer(true);
        }
    }, [selectedChoice]);

    useEffect(() => {
        if (showChoices === false) {
            setAudioVersion("NONE");
        }
    }, [showChoices]);

    useEffect(() => {
        if (launchDocument === false) {
            setTranscriptVersion("NONE");
        }
    }, [launchDocument]);


    const onChoiceDone = async (choice: { key: string, path: string[] }) => {
        togglePlayer();
        const { key, path } = choice;
        let urlToLaunch: any[] = [];
        if (activity.sectionKey === "still") {
            urlToLaunch.push(require("../../../assets/audio/lili_je_me_pose.mp3"));
        } else if (activity.sectionKey === "talk") {
            urlToLaunch.push(require("../../../assets/audio/lili_je_m_exprime.mp3"));
        }
        let audioUrls = await getUrlsToUse({ urls: path, activityKey: activity.key });
        urlToLaunch = urlToLaunch.concat(audioUrls);
        if (activity.sectionKey === "still") {
            urlToLaunch.push(require("../../../assets/audio/lili_je_me_pose.mp3"));
        } else if (activity.sectionKey === "talk") {
            urlToLaunch.push(require("../../../assets/audio/lili_je_m_exprime.mp3"));
        }
        setSelectedChoice({ key, urls: urlToLaunch });
    }

    useEffect(() => {
        if (audioVersion !== "NONE") {
            launchTheChaptersPlayer(audioVersion === "ADAPTED");
            trackEvent(analyticsEventActivityLaunch, {
                [propertiesEventCategory]: categoryAnalyticsKey,
                [propertiesEventContent]: sub_type,
                [propertiesEventAccess]: activity.isPremium() === true ? "premium" : "free",
                [propertiesEventContext]: context,
                [propertiesEventName]: audioVersion === "ADAPTED" ? activity.analytics_key + "_ADAPTED" : activity.analytics_key,
                "starting_point": starting_point
            });
        }
    }, [audioVersion]);

    useEffect(() => {
        if (transcriptVersion !== "NONE") {
            trackEvent(analyticsEventActivityLaunch, {
                [propertiesEventCategory]: categoryAnalyticsKey,
                [propertiesEventContent]: "doc",
                [propertiesEventContentName]: transcriptVersion === "ADAPTED" ? "tapuscrit_adapted" : "tapuscrit",
                [propertiesEventAccess]: activity.isPremium() === true ? "premium" : "free",
                [propertiesEventName]: activity.analytics_key
            });
            setLaunchDocument(true);
            setShowTranscriptChoices(false);
        }
    }, [transcriptVersion]);

    const launchTheChaptersPlayer = async (adapted: boolean) => {
        let chaptersUrls: string[] = selectedChoice.urls !== undefined ? selectedChoice.urls : audioUrls;
        let chaptersDescription: string[] = activity.action.chapters !== undefined ? activity.action.chapters : [];
        let chaptersImages: { app: string, db: string }[] = [];
        if (activity.action.audio_chapters !== undefined) {
            // Si on a la nouvelle structure des chapitres, on l'utilise en l'adaptant au player par chapitre pour ne pas apporter trop de changement au code
            let audioChapters: { description: { body?: localizedString, title?: localizedString }, audio: localizedString, imgs?: { app: string, db: string }[] }[] = [];
            if ((activity.action.audio_chapters.original !== undefined) && (adapted === false)) {
                audioChapters = activity.action.audio_chapters.original;
            } else if ((activity.action.audio_chapters.adapted !== undefined) && (adapted === true)) {
                audioChapters = activity.action.audio_chapters.adapted;
            }
            chaptersUrls = [];
            chaptersDescription = [];
            for (const aChapterIndex in audioChapters) {
                if (Object.prototype.hasOwnProperty.call(audioChapters, aChapterIndex)) {
                    const aChapter: { title: localizedString, audio: localizedString, imgs?: { app: string, db: string }[] } = audioChapters[aChapterIndex];
                    chaptersUrls.push(aChapter.audio[getLanguage()]);
                    chaptersDescription.push(aChapter.description);
                    if ((aChapter.imgs !== undefined) && (aChapter.imgs.length > 0)) {
                        chaptersImages.push(aChapter.imgs);
                    } else {
                        chaptersImages.push({ app: "", db: "" });
                    }
                }
            }
        }
        const recheckAudioUrls = await getUrlsToUse({ urls: chaptersUrls, activityKey: activity.key, isAdaptedVersion: adapted });
        actionSheetRef.current.showAlert({
            actionSheetType: "AUDIO_CHAPTER",
            data: {
                adapted,
                categoryAnalyticsKey,
                isPremium: activity.isPremium,
                activityAnalyticsKey: activity.analytics_key,
                title: activity.title[getLanguage()],
                urls: recheckAudioUrls,
                chapters: chaptersDescription,
                localImage: activity.app_image,
                remoteImage: activity.img_url,
                color: props.color,
                activityId: activity.key,
                chaptersImages,
                onActivityCompleted: onActivityCompletedForGamification
            }
        });
        setShowChoices(false);
    }

    const closeTheChoicesModal = () => {
        if (showChoices === true) {
            setShowChoices(false);
        } else if (showTranscriptChoices === true) {
            setShowTranscriptChoices(false);
        }
    }

    const getModalContent = () => {
        if ((showChoices === false) && (showTranscriptChoices === false)) {
            return <View />
        }
        if ((activity !== undefined) && (((activity.action !== undefined) && (showChoices === true)) || ((activity.transcript !== undefined) && (showTranscriptChoices === true)))) {
            const { choices, audio_chapters } = activity.action;
            if ((choices !== undefined) || (audio_chapters !== undefined)) {
                let choicesTitle: string = "";
                let choicesView: React.JSX.Element[] = [];
                const marginHorizontal = appTheme.pixelPerfect(20);
                const buttonWidth = width - marginHorizontal * 2;
                const buttonPadding = appTheme.pixelPerfect(5);
                const iconWidth = appTheme.pixelPerfect(40);
                const textWidth = buttonWidth - iconWidth - 2 * buttonPadding;
                const buttonFontSize = appTheme.pixelPerfectForFont(12);
                const buttonHeight = appTheme.pixelPerfect(64);
                const windowMarginBottom = Platform.OS === "web" ? appTheme.pixelPerfect(20) : 0;
                if (choices !== undefined) {
                    const { main_sub_type, others, title, main, intro } = choices;
                    if ((intro !== undefined) && (intro[getLanguage()] !== undefined)) {
                        // Ajouter en version 668 pour plus de flexibilité
                        choicesTitle = intro[getLanguage()];
                    } else if (title !== undefined) {
                        choicesTitle = i18n.t("choices." + title);
                    }
                    // On va créer kes choix en fonctions de ce qui est présent dans le tableau
                    // Le premier choix est l'audio par défaut
                    let mainChoiceTitle: string = "";
                    // Ajouter en version 668 pour plus de flexibilité
                    if ((choices.main !== undefined) && (choices.main.title !== undefined) && (choices.main.title[getLanguage()] !== undefined)) {
                        mainChoiceTitle = choices.main.title[getLanguage()];
                    } else if (choices.main_sub_type !== undefined) {
                        mainChoiceTitle = i18n.t("choices." + main_sub_type);
                    }
                    choicesView.push(<TouchableOpacity key="main" onPress={() => onChoiceDone({ key: "main", path: activity.action.audio[getLanguage()] })} style={{ paddingHorizontal: buttonPadding, flexDirection: "row", alignItems: "center", justifyContent: "space-around", backgroundColor: appTheme.white, width: buttonWidth, height: buttonHeight, borderRadius: appTheme.pixelPerfect(20), marginBottom: appTheme.pixelPerfect(20) }}>
                        <View style={{ width: iconWidth, alignItems: "center", justifyContent: "center" }}>
                            <SVGView Component={IcHeadphones} size={30} color={props.color} />
                        </View>
                        <View style={{ flex: 1, alignItems: "center", justifyContent: "center" }}>
                            <Text numberOfLines={3} style={{ textAlign: "center", fontFamily: appTheme.secondaryFont, fontSize: buttonFontSize, color: props.color, width: textWidth }}>{mainChoiceTitle.toLocaleUpperCase()}</Text>
                        </View>
                    </TouchableOpacity>);
                    for (const aChoiceIndex in others) {
                        if (Object.prototype.hasOwnProperty.call(others, aChoiceIndex)) {
                            const aChoice: actionChoice = others[aChoiceIndex];
                            const svgIcon = aChoice.type === "audio" ? IcHeadphones : aChoice.type === "video" ? IcFilm : IcDocument;
                            let aChoiceTitle: string = "";
                            // Ajouter en version 668 pour plus de flexibilité
                            if ((aChoice.title !== undefined) && ((aChoice.title[getLanguage()] !== undefined))) {
                                aChoiceTitle = aChoice.title[getLanguage()];
                            } else if (aChoice.sub_type !== undefined) {
                                aChoiceTitle = i18n.t("choices." + aChoice.sub_type);
                            }
                            choicesView.push(<TouchableOpacity key={aChoice.key} onPress={() => onChoiceDone({ key: aChoice.key, path: [aChoice.url[getLanguage()]] })} style={{ paddingHorizontal: buttonPadding, flexDirection: "row", alignItems: "center", justifyContent: "space-around", backgroundColor: appTheme.white, width: buttonWidth, height: buttonHeight, borderRadius: appTheme.pixelPerfect(20), marginBottom: appTheme.pixelPerfect(20) }}>
                                <View style={{ width: iconWidth, alignItems: "center", justifyContent: "center" }}>
                                    <SVGView Component={svgIcon} size={30} color={props.color} />
                                </View>
                                <View style={{ flex: 1, alignItems: "center", justifyContent: "center" }}>
                                    <Text numberOfLines={3} style={{ textAlign: "center", fontFamily: appTheme.secondaryFont, fontSize: buttonFontSize, color: props.color, width: textWidth }}>{ aChoiceTitle.toLocaleUpperCase() }</Text>
                                </View>
                            </TouchableOpacity>);
                        }
                    }
                } else if (showChoices === true) {
                    choicesTitle = "Écoutez ce podcast";
                    choicesView.push(<TouchableOpacity onPress={() => setAudioVersion("ORIGINAL")} key="original" style={{ paddingHorizontal: buttonPadding, flexDirection: "row", alignItems: "center", justifyContent: "space-around", backgroundColor: appTheme.white, width: buttonWidth, height: buttonHeight, borderRadius: appTheme.pixelPerfect(14), marginBottom: appTheme.pixelPerfect(20) }}>
                        <View style={{ flex: 1, alignItems: "center", justifyContent: "center" }}>
                            <Text numberOfLines={3} style={{ textAlign: "center", fontFamily: appTheme.primarySemiBoldFont, fontSize: buttonFontSize, color: appTheme.darkBlue, width: textWidth }}>{i18n.t("choices.original_version").toLocaleUpperCase()}</Text>
                        </View>
                    </TouchableOpacity>);
                    choicesView.push(<TouchableOpacity onPress={() => setAudioVersion("ADAPTED")} key="adapted" style={{ paddingHorizontal: buttonPadding, flexDirection: "row", alignItems: "center", justifyContent: "space-around", backgroundColor: appTheme.white, width: buttonWidth, height: buttonHeight, borderRadius: appTheme.pixelPerfect(14), marginBottom: appTheme.pixelPerfect(20) }}>
                        <View style={{ flex: 1, alignItems: "center", justifyContent: "center" }}>
                            <Text numberOfLines={3} style={{ textAlign: "center", fontFamily: appTheme.primarySemiBoldFont, fontSize: buttonFontSize, color: appTheme.darkBlue, width: textWidth }}>{i18n.t("choices.adapted_version").toLocaleUpperCase()}</Text>
                        </View>
                    </TouchableOpacity>);
                } else if (showTranscriptChoices === true) {
                    choicesTitle = "Affichez le tapuscrit";
                    choicesView.push(<TouchableOpacity onPress={() => setTranscriptVersion("ORIGINAL")} key="original" style={{ paddingHorizontal: buttonPadding, flexDirection: "row", alignItems: "center", justifyContent: "space-around", backgroundColor: appTheme.white, width: buttonWidth, height: buttonHeight, borderRadius: appTheme.pixelPerfect(14), marginBottom: appTheme.pixelPerfect(20) }}>
                        <View style={{ flex: 1, alignItems: "center", justifyContent: "center" }}>
                            <Text numberOfLines={3} style={{ textAlign: "center", fontFamily: appTheme.primarySemiBoldFont, fontSize: buttonFontSize, color: appTheme.darkBlue, width: textWidth }}>{i18n.t("choices.original_version").toLocaleUpperCase()}</Text>
                        </View>
                    </TouchableOpacity>);
                    choicesView.push(<TouchableOpacity onPress={() => setTranscriptVersion("ADAPTED")} key="adapted" style={{ paddingHorizontal: buttonPadding, flexDirection: "row", alignItems: "center", justifyContent: "space-around", backgroundColor: appTheme.white, width: buttonWidth, height: buttonHeight, borderRadius: appTheme.pixelPerfect(14), marginBottom: appTheme.pixelPerfect(20) }}>
                        <View style={{ flex: 1, alignItems: "center", justifyContent: "center" }}>
                            <Text numberOfLines={3} style={{ textAlign: "center", fontFamily: appTheme.primarySemiBoldFont, fontSize: buttonFontSize, color: appTheme.darkBlue, width: textWidth }}>{i18n.t("choices.adapted_version").toLocaleUpperCase()}</Text>
                        </View>
                    </TouchableOpacity>);
                }
                const modaleBackgroundColor: string = modal_color !== undefined ? modal_color : color;
                return <View style={[Style.shadowed, { paddingTop: appTheme.pixelPerfect(10), backgroundColor: modaleBackgroundColor, width, borderRadius: appTheme.pixelPerfect(10), alignItems: "center", marginBottom: windowMarginBottom }]}>
                    <View style={{ marginBottom: appTheme.pixelPerfect(20), width, paddingHorizontal: appTheme.pixelPerfect(10), alignItems: "flex-end" }}>
                        <TouchableOpacity onPress={closeTheChoicesModal} style={{ backgroundColor: appTheme.white, width: appTheme.pixelPerfect(30), height: appTheme.pixelPerfect(30), borderRadius: appTheme.pixelPerfect(15), justifyContent: "center", alignItems: "center" }}>
                            <SVGView Component={IcClose} size={20} color={color} />
                        </TouchableOpacity>
                    </View>
                    <Text style={{ paddingHorizontal: appTheme.pixelPerfect(20), textAlign: "center", fontFamily: appTheme.primarySemiBoldFont, fontSize: appTheme.pixelPerfectForFont(16), color: appTheme.darkBlue }}>
                        {choicesTitle}
                    </Text>
                    <View style={{ marginVertical: appTheme.pixelPerfect(20) }}>
                        {choicesView}
                    </View>
                </View>;
            }
        }
        return <View />;
    }

    const togglePlayer = () => {
        if (launchPlayer === true) {
            setLaunchPlayer(false);
        } else {
            if (activity.action.choices !== undefined) {
                // Si l'audio a des choix "simples", on va montrer les choix (exemple avec la relaxation avec et sans musique)
                setShowChoices((showChoices) => !showChoices);
            } else {
                setLaunchPlayer(!launchPlayer);
            }
        }
    }

    const onActivityCompletedForGamification = () => {
        onActivityCompleted({
            activityKey: activity.key,
            sectionKey: activity.sectionKey,
            categoryKey,
            iteration: 1,
            detail: "",
            menu: ""
        });
        trackEvent(analyticsEventActivityCompleted, {
            [propertiesEventCategory]: categoryAnalyticsKey,
            [propertiesEventContent]: sub_type,
            [propertiesEventAccess]: activity.isPremium() === true ? "premium" : "free",
            [propertiesEventContext]: context,
            [propertiesEventName]: activity.analytics_key,
            "starting_point": starting_point
        });
    }

    const showChapterList = async () => {
        let audioVersionSelected: audioVersionType = "NONE";
        if (activity.action.audio_chapters !== undefined) {
            if ((activity.action.audio_chapters.original !== undefined) && (activity.action.audio_chapters.adapted !== undefined)) {
                // Si une activité est disponible en version "adapatées" avec des images clés, on va lancer le choix d'écouter la version classique ou adaptées
                setShowChoices((showChoices) => !showChoices);
            } else if (activity.action.audio_chapters.original !== undefined) {
                audioVersionSelected = "ORIGINAL";
                setAudioVersion("ORIGINAL");
            } else if (activity.action.audio_chapters.adapted !== undefined) {
                audioVersionSelected = "ADAPTED";
                setAudioVersion("ADAPTED");
            }
        } else {
            setAudioVersion("ORIGINAL");
        }
        if (audioVersionSelected !== "NONE") {
            trackEvent(analyticsEventActivityLaunch, {
                [propertiesEventCategory]: categoryAnalyticsKey,
                [propertiesEventContent]: sub_type,
                [propertiesEventAccess]: activity.isPremium() === true ? "premium" : "free",
                [propertiesEventContext]: context,
                [propertiesEventName]: audioVersionSelected === "ADAPTED" ? activity.analytics_key + "_ADAPTED" : activity.analytics_key,
                "starting_point": starting_point
            });
        }

    }

    const openTheDocument = (withAdaptedVersion: boolean) => {
        if (withAdaptedVersion === false) {
            // On ouvre le doc
            trackEvent(analyticsEventActivityLaunch, {
                [propertiesEventCategory]: categoryAnalyticsKey,
                [propertiesEventContent]: "doc",
                [propertiesEventContentName]: "tapuscrit",
                [propertiesEventAccess]: activity.isPremium() === true ? "premium" : "free",
                [propertiesEventName]: activity.analytics_key
            });
            setLaunchDocument(true);
        } else {
            setShowTranscriptChoices(true);
        }
    }

    const openTheImagesSlideShow = () => {
        setLaunchImagesSlideshow(true);
        trackEvent(analyticsEventActivityLaunch, {
            [propertiesEventCategory]: categoryAnalyticsKey,
            [propertiesEventContent]: "key_images",
            [propertiesEventContentName]: "slideshow",
            [propertiesEventAccess]: activity.isPremium() === true ? "premium" : "free",
            [propertiesEventName]: activity.analytics_key
        });
    }

    const renderImagesSlideShow = () => {
        if (launchImagesSlideshow === false) {
            return <View />
        }
        let imagesToDisplaySource: { app: string, db: string }[] = [];
        if ((activity.action.audio_chapters !== undefined) && (activity.action.audio_chapters.adapted !== undefined)) {
            for (const aChapterIndex in activity.action.audio_chapters.adapted) {
                if (Object.prototype.hasOwnProperty.call(activity.action.audio_chapters.adapted, aChapterIndex)) {
                    const aChapter: { title: localizedString, audio: localizedString, imgs?: { app: string, db: string }[] } = activity.action.audio_chapters.adapted[aChapterIndex];
                    if (aChapter.imgs !== undefined) {
                        for (const anImageIndex in aChapter.imgs) {
                            if (Object.prototype.hasOwnProperty.call(aChapter.imgs, anImageIndex)) {
                                const aChapterImg: { app: string, db: string } = aChapter.imgs[anImageIndex];
                                imagesToDisplaySource.push(aChapterImg);
                            }
                        }
                    }
                }
            }
        }

        return <ImagesSlideshow slideshowImages={imagesToDisplaySource} color={color} closeTheGame={() => setLaunchImagesSlideshow(false)} />
    }

    const getActionButton = () => {
        if (viewDidAppear === false) {
            return <ActivityIndicator loading={!viewDidAppear} color={color} />
        }
        let buttonTitleView = <View />;
        if (sub_type === "audio_chapters") {
            buttonTitleView = <Text style={{ paddingTop: appTheme.pixelPerfect(10), fontFamily: appTheme.secondaryFont, color, fontSize: appTheme.pixelPerfectForFont(12), alignItems: "center" }}>
                {"Podcast"}
            </Text>;
        }
        const activityActionButtton = isEnable === true ? <View key={"play"} style={{ alignItems: "center" }}>
            <PlayButton size={appTheme.pixelPerfect(70)} disabled={audioUrls.length === 0} onPress={sub_type === "audio_chapters" ? showChapterList : togglePlayer} backgroundColor={color} />
            {buttonTitleView}
        </View> : <PremiumButton componentId={componentId} />;
        let actionButtonContent = [activityActionButtton];
        if (isEnable === true) {
            // On regarde s'il y a un tapuscrit
            let transcriptName: string = "Tapuscrit";
            // On va regarder d'abord s'il a des tapuscrit "qualifié" sinon on regarde les documents "classique"
            let showTranscript: boolean = false;
            let showTranscriptWithAdaptedVersion: boolean = false;
            if ((activity.transcript !== undefined) && ((activity.transcript.adapted !== undefined) || (activity.transcript.original !== undefined))) {
                showTranscript = true;
                showTranscriptWithAdaptedVersion = true;
            } else if ((activity.document !== undefined) && (activity.document[getLanguage()] !== undefined) && (activity.document[getLanguage()].file !== undefined)) {
                showTranscript = true;
                showTranscriptWithAdaptedVersion = false;
            }
            if (showTranscript === true) {
                const openTranscriptButton = <View key={"transcript"} style={{ alignItems: "center", marginStart: appTheme.pixelPerfect(20) }}>
                    <RoundIconButton onPress={() => openTheDocument(showTranscriptWithAdaptedVersion)} iconName={IcTapuscrit} backgroundColor={color} />
                    <Text style={{ textAlign: "center", paddingTop: appTheme.pixelPerfect(10), fontFamily: appTheme.secondaryFont, color, fontSize: appTheme.pixelPerfectForFont(12), alignItems: "center" }}>
                        {transcriptName}
                    </Text>
                </View>;
                actionButtonContent.push(openTranscriptButton);
            }

            // On regarde s'il y a des images clés pour les activités adaptées
            let keyImagesName: string = "Images-clés";
            if ((activity.key_images !== undefined) && (activity.key_images === true)) {
                const openKeyImagesButton = <View key={"key_images"} style={{ alignItems: "center", marginStart: appTheme.pixelPerfect(20) }}>
                    <RoundIconButton iconSize={appTheme.pixelPerfect(28)} onPress={openTheImagesSlideShow} iconName={IcKeyImages} backgroundColor={color} />
                    <Text style={{ textAlign: "center", paddingTop: appTheme.pixelPerfect(10), fontFamily: appTheme.secondaryFont, color, fontSize: appTheme.pixelPerfectForFont(12), alignItems: "center" }}>
                        {keyImagesName}
                    </Text>
                </View>;
                actionButtonContent.push(openKeyImagesButton);
            }
        }
        return <View style={{ flexDirection: "row", width, justifyContent: "center" }}>
            {actionButtonContent}
        </View>
    }

    const getDocumentModal = () => {
        if (launchDocument === false) {
            return <View />
        }
        let pdfUrl: string = "";
        let title: string = "";
        let isAdapted: boolean = false;
        if ((activity.transcript !== undefined) && ((activity.transcript.adapted !== undefined) || (activity.transcript.original !== undefined))) {
            if (transcriptVersion === "ADAPTED") {
                if ((activity.transcript.adapted.document !== undefined) && (activity.transcript.adapted.document[getLanguage()] !== undefined)) {
                    isAdapted = true;
                    pdfUrl = activity.transcript.adapted.document[getLanguage()];
                    if (activity.transcript.adapted.title[getLanguage()] !== undefined) {
                        title = activity.transcript.adapted.title[getLanguage()];
                    }
                }
            } else if (transcriptVersion === "ORIGINAL") {
                if ((activity.transcript.original.document !== undefined) && (activity.transcript.original.document[getLanguage()] !== undefined)) {
                    pdfUrl = activity.transcript.original.document[getLanguage()];
                    if (activity.transcript.original.title[getLanguage()] !== undefined) {
                        title = activity.transcript.original.title[getLanguage()];
                    }
                }
            }
        } else if ((activity.document !== undefined) && (activity.document[getLanguage()] !== undefined) && (activity.document[getLanguage()].file !== undefined)) {
            pdfUrl = activity.document[getLanguage()].file;
            title = activity.title[getLanguage()];
        }
        if (pdfUrl.length > 0) {
            if (appTarget !== "public") {
                pdfUrl = getDocumentUrlForActivityId({ activity_id: activity.key, isAdapted });
            }
            return <PDFViewer
                title={title}
                pdfUrl={pdfUrl}
                color={color}
                sectionId={activity.sectionKey}
                closeTheDocument={() => setLaunchDocument(false)} />
        }

        return <View />;
    }


    return <View onLayout={onViewDidAppear} style={{ width, alignItems: "center", marginTop: appTheme.pixelPerfect(10) }}>
        {getActionButton()}
        <Modal animationType="slide" visible={showChoices || showTranscriptChoices} transparent={true} style={{ width: appTheme.getFullScreenWidth() }}>
            <View style={{ flex: 1, alignItems: "center", backgroundColor: appTheme.white + "80", width: appTheme.getFullScreenWidth() }}>
                <View style={{ paddingLeft:appTheme.webNavBarWidth, flex: 1, justifyContent: "flex-end", alignItems: "center", width: appTheme.getFullAppWidth() }}>
                    {getModalContent()}
                </View>
            </View>
        </Modal>
        <Modal animationType="slide" visible={launchPlayer} transparent={true} style={{ width: appTheme.getFullScreenWidth(), height:"100%" }}>
            <View style={{ flex: 1, alignItems: "center", width: appTheme.getFullScreenWidth() }}>
                <View style={{ paddingLeft:appTheme.webNavBarWidth, flex: 1, alignItems: "center", justifyContent: "flex-end", backgroundColor: color + "80", width: appTheme.getFullScreenWidth(), paddingBottom: appTheme.pixelPerfect(20) }}>
                    <ActivityPlayer
                        activityKey={activity.key}
                        title={activity.title[getLanguage()]}
                        notificationImage={Platform.OS === "ios" ? activity.img_url : localImgPath}
                        onActivityCompleted={onActivityCompletedForGamification}
                        urls={selectedChoice.urls !== undefined ? selectedChoice.urls : audioUrls}
                        color={props.color}
                        localImage={localImgPath}
                        remoteImage={activity.img_url}
                        togglePlayer={togglePlayer} />
                </View>
            </View>
        </Modal>
        <Modal animationType="slide" visible={launchDocument} transparent={true} style={{ width: appTheme.getFullScreenWidth() }}>
            <View style={{ flex: 1, alignItems: "center", backgroundColor: color + "80", width: appTheme.getFullScreenWidth() }}>
                <View style={{ flex: 1, justifyContent: "flex-end", backgroundColor: color + "80", width: appTheme.getFullAppWidth() }}>
                    {getDocumentModal()}
                </View>
            </View>
        </Modal>
        <Modal animationType="slide" visible={launchImagesSlideshow} transparent={false} style={{ flex: 1 }}>
            <View style={{ backgroundColor: color + "80", width: appTheme.getFullScreenWidth(), height: appTheme.getFullScreenHeight() }}>
                {renderImagesSlideShow()}
            </View>
        </Modal>
        <ActionSheet textColor={color} componentId={props.componentId} ref={actionSheetRef} onChange={() => { }} />
    </View>

}

export default ActivityCellActionAudio;